(() => {
  const init = () => {
    const mobile = window.matchMedia('(max-width: 767px)');
    const zh = document.documentElement.lang.toLowerCase().startsWith('zh');
    const label = zh ? '點擊查看大圖' : 'Tap to view full-size image';
    const apply = () => {
      if (!mobile.matches) return;
      for (const body of document.querySelectorAll('.gp-plant-full-details--mobile > .gp-plant-full-details__body')) {
        for (const img of body.querySelectorAll('img')) {
          if (img.closest('a, picture, button')) continue;
          const source = img.getAttribute('src') || img.currentSrc;
          if (!source) continue;
          const url = new URL(source, document.baseURI);
          if (!['https:', 'http:'].includes(url.protocol)) continue;
          const link = document.createElement('a');
          link.className = 'gp-plant-details-image-link';
          link.href = url.href;
          link.target = '_blank';
          link.rel = 'noopener';
          link.setAttribute('aria-label', `${img.alt ? img.alt + ' — ' : ''}${label}${zh ? '（新視窗）' : ' (opens in a new tab)'}`);
          const caption = document.createElement('span');
          caption.className = 'gp-plant-details-image-caption';
          caption.textContent = label;
          img.before(link);
          link.append(img, caption);
        }
        for (const table of body.querySelectorAll('table')) {
          if (table.closest('.gp-plant-details-table')) continue;
          const existing = table.closest('.hdt-scrollable-wrapper');
          const wrap = existing || document.createElement('div');
          wrap.classList.add('gp-plant-details-table');
          wrap.tabIndex = 0;
          wrap.setAttribute('role', 'region');
          wrap.setAttribute('aria-label', zh ? '詳細規格，可橫向滑動' : 'Detailed specifications, scroll horizontally');
          if (!existing) { table.before(wrap); wrap.append(table); }
        }
      }
    };
    apply();
    mobile.addEventListener('change', apply);
    document.addEventListener('shopify:section:load', apply);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
